/** @format */

import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { useGlobal } from 'reactn';
import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import Spacer from '../../../../../../components/Commons/Spacer';
import CustomButton from '../../../../../../v2-components/Antd/Button';
import './style.scss';
import { GlobalConsumer } from '../../../../../../components/Commons/Context/Global';

export default function CheckoutButtonRetirement(props) {
	const [isLoading] = useGlobal('retirementButtonLoading');
	const [isMobile, setMobile] = useState(false);
	const { isSelectionRetirementType, setSelectionRetirementError } = GlobalConsumer();
	const [isAddressValidated] = useGlobal('isAddressValidated');
	// eslint-disable-next-line
	const [isDirectionValidation, setDirectionValidation] = useGlobal('directionValidation');
	

	useEffect(() => {
		if (window.innerWidth < 992) {
			setMobile(true);
		}
	}, []);

	const buttonClass = props.type === 'retirement' && !isMobile ? 'ph-checkout-withdrawal-button-full' : 'button-primary';

	const handleTypeError = () => {
		if (isSelectionRetirementType === null) {
			setSelectionRetirementError(true);
		}

		if (isSelectionRetirementType === 'delivery' && !isAddressValidated) { 
			setDirectionValidation(true);
		}
	};

	return (
		<Form.Item className="ph-checkout-withdrawal-button-main-container">
			{isMobile && (
				<>
					<div>
						<h3 className="ph-checkout-withdrawal-button-mobile-price-main-title">Total a pagar:</h3>
						<h3 className="ph-checkout-withdrawal-button-mobile-price-title">
							<span className="ph-checkout-withdrawal-button-mobile-price-description">$</span>
							{props.item.total}
						</h3>
					</div>
					<Spacer />
				</>
			)}
			<CustomButton className={buttonClass} loading={isLoading} htmlType={'submit'} onClick={handleTypeError}>
				{Enviroment.ROOT_RESERVE ? 'CONSULTAR STOCK' : 'Siguiente'}
			</CustomButton>
		</Form.Item>
	);
}
